'use client'
import { useEffect, useState } from 'react'
import lottie from 'lottie-web'
export interface ILottie {
  isActive: boolean,
  name: string,
  speed?: number
}

const useLottie = (name, loop = true) => {
  const [ref, setRef] = useState(null)
  const [animation, setAnimation] = useState(null)

  const register = (ref) => {
    if (ref) setRef(ref)
  }

  useEffect(() => {
    if (ref && lottie && !animation) {
      const _animation = lottie?.loadAnimation({
        container: ref,
        renderer: 'svg',
        loop,
        autoplay: false,
        path: `/lottie/${name}.json`,
        name
      })

      if(_animation) setAnimation(_animation)
    }

    return () => { animation?.destroy() }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, lottie, animation])

  return { register, animation }
}

export const Lottie = ({ isActive, name, speed = 1 }:ILottie) => {
  const { animation, register } = useLottie(name)

  useEffect(() => {
    if (animation && isActive) {
      animation?.setSpeed(speed)
      animation?.play()
    }

    return () => animation && animation?.stop()
  }, [isActive, animation, speed])

  return (
    <div className={'lottie-container ' + name} ref={register}/>
  )
}
